import { render } from "./UserOrganizationsCard.vue?vue&type=template&id=4f7f4f8c"
import script from "./UserOrganizationsCard.vue?vue&type=script&lang=js"
export * from "./UserOrganizationsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__